module.exports = __webpack_public_path__ + "12017a29c44bab28ac0e71a5920bdf87.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-regular.eot
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9